import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _typeof from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/typeof";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import samplingCustom from "./components/samplingCustom";
import refreshCustom from "./components/refreshCustom";
import moreCustom from "./components/moreCustom";
import Historyrouter from "../historyrouter/historyrouter";
import DistributionLog from "../devicedistribution/distributionLog";
import Control from "../control/control.vue";
import AlermDes from "../../alarmManage/alermDes/alermDes.vue";
import logoImg1 from "@/assets/images/battery1.png";
import logoImg2 from "@/assets/images/battery2.png";
import logoImg3 from "@/assets/images/battery3.png";
import logoImg4 from "@/assets/images/battery4.png";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import echarts from "echarts";
import { formatYMD } from "@/libs/util";
import { progress_firmware, iotdatalastget as _iotdatalastget, get_rl_trends as _get_rl_trends, get_yx_trends as _get_yx_trends, web_issue_order, get_firmware_info, upup_firmware, config_caiyang_pinglv, config_nibianqi, get_now_lnglat, did_config_pass } from "@/api/jingxiaoshang";
import { get_qr_code, dldpset } from "@/api/chuku";
import axios from "axios";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      currDidTab: "",
      map: null,
      qr_boolean_click: false,
      qr_boolean: false,
      //是否显示二维码
      qr_url: null,
      //二维码地址
      battery: null,
      //电池
      SN: null,
      //设备SN
      assign_time: null,
      //更新时间
      deviclposition: [],
      //设备位置
      changepl: 0,
      modal7: false,
      result_firmware: [],
      pack_check: 1,
      password: null,
      passwordTypeIcon: "ios-eye",
      passwordType: "password",
      pack_data: [],
      pack_data_dt: [],
      //单体数据
      chans: [],
      is_web_time: 1,
      progress_text: "",
      is_shengji: 1,
      is_jindu: 0,
      progress_percent: 0,
      progress_dingshi: null,
      dp_chan_list: [{
        value: 0
      }],
      maxinfo: 0,
      maxinfo2: 0,
      alertTotalList: 0,
      alertTimeList: [],
      alertDataList: [],
      alertTimeList2: [],
      alertDataList2: [],
      alertTimeList3: [],
      alertDataList3: [],
      is_day: 0,
      is_month: 0,
      is_year: 0,
      textValue: this.$t("容量分析"),
      button1: "new_button_check",
      button2: "new_button",
      button3: "new_button",
      button4: "new_button",
      legendData3: [],
      xAxisData3: [],
      seriesData3: [],
      rongliang_trends: [],
      check_did: "",
      firmware_list: [],
      spinShow: true,
      show_caiyang: false,
      dui: {},
      bingji: [],
      imgLogo1: logoImg1,
      imgLogo2: logoImg2,
      imgLogo3: logoImg3,
      imgLogo4: logoImg4,
      can_lineData: [],
      chuan_lineData: [],
      local: "zh-CN",
      wang_lineData: [],
      dingshi: null,
      shuaxin: 60,
      caiyang_pinglv: 0,
      uploadLoading: false,
      details_data: [],
      did: "",
      buttonSize2: "BMU1",
      buttonSize1: "BCU1",
      charge: 0,
      discharge: 0,
      columns11: [{
        title: "",
        //    slot: 'name',
        key: "name"
      }, {
        title: "1",
        key: "a1"
      }, {
        title: "2",
        key: "a2"
      }, {
        title: "3",
        key: "a3"
      }, {
        title: "4",
        key: "a4"
      }, {
        title: "5",
        key: "a5"
      }, {
        title: "6",
        key: "a6"
      }, {
        title: "7",
        key: "a7"
      }, {
        title: "8",
        key: "a8"
      }],
      data11: [{
        name: "电压",
        a1: "1.1V",
        a2: "1.1V",
        a3: "1.1V",
        a4: "1.1V",
        a5: "1.1V",
        a6: "1.1V",
        a7: "1.1V",
        a8: "1.1V"
      }],
      data12: [{
        name: "温度",
        a1: "1.1V",
        a2: "1.1V",
        a3: "1.1V",
        a4: "1.1V",
        a5: "1.1V",
        a6: "1.1V",
        a7: "1.1V",
        a8: "1.1V"
      }],
      data13: [{
        name: "端子温度",
        a1: "1.1V",
        a2: "1.1V",
        a3: "1.1V",
        a4: "1.1V",
        a5: "1.1V",
        a6: "1.1V",
        a7: "1.1V",
        a8: "1.1V"
      }],
      devicename: "aaaaaaaa",
      columns4: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "参数名",
        key: "param_name"
      }, {
        title: "当前值",
        key: "now_value"
      }, {
        title: "设置值",
        key: "config_value",
        slot: "action"
      }, {
        title: "操作",
        key: "action",
        width: 150,
        align: "center",
        render: function render(h, params) {
          return h("div", [h("Button", {
            props: {
              type: "primary",
              size: "small"
            },
            style: {
              marginRight: "5px"
            },
            on: {
              click: function click() {
                _this2.show(params.index);
              }
            }
          }, "发送")]);
        }
      }],
      data1: [{
        id: 1,
        param_name: "单体高压1_保护值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压1_保护延时",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压1_保护恢复值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压1_保护恢复延时",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压2_保护值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压2_保护延时",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压2_保护恢复值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压2_保护恢复延时",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压3_保护值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压3_保护延时",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压3_保护恢复值",
        now_value: 18,
        config_value: 22
      }, {
        id: 1,
        param_name: "单体高压3_保护恢复延时",
        now_value: 18,
        config_value: 22
      }],
      show1_1: true,
      show1_2: true,
      show1_3: true,
      is_update: 100,
      tabData: [{
        name: "单体高压",
        value: 1
      }, {
        name: "单体低压",
        value: 2
      }, {
        name: "总体高压",
        value: 3
      }, {
        name: "总体低压",
        value: 4
      }, {
        name: "充电过流",
        value: 5
      }, {
        name: "放电过流",
        value: 6
      }, {
        name: "充电高温",
        value: 7
      }, {
        name: "充电低温",
        value: 8
      }, {
        name: "放电高温",
        value: 9
      }, {
        name: "放电低温",
        value: 10
      }, {
        name: "充电温差",
        value: 11
      }, {
        name: "放电温差",
        value: 12
      }, {
        name: "电芯温升",
        value: 13
      }, {
        name: "SOC高",
        value: 14
      }, {
        name: "SOC低",
        value: 15
      }, {
        name: "正极绝缘漏电",
        value: 16
      }, {
        name: "负极绝缘漏电",
        value: 17
      }, {
        name: "环境高温",
        value: 18
      }, {
        name: "环境低温",
        value: 19
      }, {
        name: "充电压差",
        value: 20
      }, {
        name: "放电压差",
        value: 21
      }, {
        name: "端子高温",
        value: 22
      }, {
        name: "风扇控制",
        value: 23
      }, {
        name: "电芯故障",
        value: 24
      }, {
        name: "满充参数",
        value: 25
      }, {
        name: "均衡参数",
        value: 26
      }, {
        name: "容量",
        value: 27
      }, {
        name: "短路保护",
        value: 28
      }, {
        name: "掉电开关",
        value: 29
      }, {
        name: "继电器控制",
        value: 30
      }, {
        name: "基础控制",
        value: 31
      }, {
        name: "保护功能",
        value: 32
      }],
      form_filter: {
        tabname: null
      },
      form_filter2: {
        search_type: 1,
        search_date: null
      },
      form_filter3: {
        date: null
      },
      formModel: {
        dp_chan: 0,
        dcac_canid: null,
        dcac_comid: null,
        dcac_netid: null
      },
      tab_check: "",
      //共用的查询与重置
      topButtonList: [{
        name: "查询",
        type: "primary",
        method: this.search
      }, {
        name: "重置",
        type: "error",
        method: this.reset
      }]
    };
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2,
    DistributionLog: DistributionLog,
    AlermDes: AlermDes,
    Historyrouter: Historyrouter,
    Control: Control
  },
  methods: {
    on_changechan: function on_changechan(val) {
      this.details_data["PACK详情数据"] = this.pack_data[val - 1];
      this.details_data["单体数据"][""] = this.pack_data_dt[val - 1];
      this.get_yx_trends();
      this.get_rl_trends();
      var res2 = {
        body: {
          单体数据: {
            "": this.pack_data_dt[val - 1]
          }
        }
      };
      this.zhexian(res2);
    },
    zhexian: function zhexian(res) {
      this.alertTimeList.splice(0);
      this.alertDataList.splice(0);
      this.alertTimeList2.splice(0);
      this.alertDataList2.splice(0);
      console.log('SDAD', this.is_web_time);

      if (this.is_web_time == 1) {
        //趋势数据
        var tem1 = [];
        var x_axis = 0;
        var xzhou = []; //  alert(res.body['单体数据'][""].cell_voltage[2]);

        if (res.body["单体数据"][""]) {
          for (var i = 0; i < res.body["单体数据"][""].cell_voltage.length; i++) {
            var list = res.body["单体数据"][""].cell_voltage[i];
            tem1.push(list);
            this.maxinfo = res.body["单体数据"][""].ghll.dianya_high + 2000;
            x_axis = i + 1;
            console.log("x_axis", x_axis);
            xzhou.push(x_axis);
          }

          this.alertTimeList = xzhou;
          this.alertDataList.push({
            name: this.$t("电芯电压") + "（mv）",
            data: tem1,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true,
            markLine: {
              symbol: "none",
              // 去掉辅助线首尾圆点和箭头
              lineStyle: {
                color: "#999",
                type: "dashed" // 实线

              },
              data: [{
                yAxis: res.body["单体数据"][""].ghll.dianya_high,
                // 纵坐标的值，决定横向辅助线在y轴的位置
                label: {
                  formatter: this.$t("最高限制")
                }
              }, {
                yAxis: res.body["单体数据"][""].ghll.dianya_low,
                // 纵坐标的值，决定横向辅助线在y轴的位置
                label: {
                  formatter: this.$t("最低限制")
                }
              }]
            }
          }); //趋势数据

          var tem2 = [];
          var x_axis2 = 0;
          var xzhou2 = []; //  alert(res.body['单体数据'][""].cell_voltage[2]);

          for (var _i = 0; _i < res.body["单体数据"][""].cell_temperature.length; _i++) {
            var list2 = res.body["单体数据"][""].cell_temperature[_i];
            tem2.push(list2 / 10);
            this.maxinfo2 = Math.max.apply(Math, tem2) + 20;
            x_axis2 = _i + 1;
            console.log("x_axis2", x_axis2);
            xzhou2.push(x_axis2);
          }

          this.alertTimeList2 = xzhou2;
          console.log("x_axis2", xzhou2);
          this.alertDataList2.push({
            name: this.$t("电芯温度") + "（℃）",
            data: tem2,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true
          });
        }
      } else {
        //趋势数据
        var _tem = [];
        var _x_axis = 0;
        var _xzhou = []; //  alert(res.body['单体数据'][""].cell_voltage[2]);

        console.log('SDAD', res.body["单体数据"][0].cell_voltage);

        if (res.body["单体数据"][0]) {
          for (var _i2 = 0; _i2 < res.body["单体数据"][0].cell_voltage.length; _i2++) {
            var _list = res.body["单体数据"][0].cell_voltage[_i2];

            _tem.push(_list);

            this.maxinfo = res.body["单体数据"][0].ghll.dianya_high + 2000;
            _x_axis = _i2 + 1;
            console.log("x_axis", _x_axis);

            _xzhou.push(_x_axis);
          }

          this.alertTimeList = _xzhou;
          this.alertDataList.push({
            name: this.$t("电芯电压") + "（mv）",
            data: _tem,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true,
            markLine: {
              symbol: "none",
              // 去掉辅助线首尾圆点和箭头
              lineStyle: {
                color: "#999",
                type: "dashed" // 实线

              },
              data: [{
                yAxis: res.body["单体数据"][0].ghll.dianya_high,
                // 纵坐标的值，决定横向辅助线在y轴的位置
                label: {
                  formatter: this.$t("最高限制")
                }
              }, {
                yAxis: res.body["单体数据"][0].ghll.dianya_low,
                // 纵坐标的值，决定横向辅助线在y轴的位置
                label: {
                  formatter: this.$t("最低限制")
                }
              }]
            }
          }); //趋势数据

          var _tem2 = [];
          var _x_axis2 = 0;
          var _xzhou2 = []; //  alert(res.body['单体数据'][""].cell_voltage[2]);

          for (var _i3 = 0; _i3 < res.body["单体数据"][0].cell_temperature.length; _i3++) {
            var _list2 = res.body["单体数据"][0].cell_temperature[_i3];

            _tem2.push(_list2 / 10);

            this.maxinfo2 = Math.max.apply(Math, _tem2) + 20;
            _x_axis2 = _i3 + 1;
            console.log("x_axis2", _x_axis2);

            _xzhou2.push(_x_axis2);
          }

          this.alertTimeList2 = _xzhou2;
          console.log("x_axis2", _xzhou2);
          this.alertDataList2.push({
            name: this.$t("电芯温度") + "（℃）",
            data: _tem2,
            type: "line",
            lineStyle: {
              width: 2
            },
            smooth: true
          });
        }
      }
    },
    dateChange: function dateChange(val) {
      //alert(val)
      if (val) {
        this.$set(this.form_filter2, "search_date", val);
        this.get_rl_trends();
      }
    },
    dateChange2: function dateChange2(val) {
      //alert(val)
      if (val) {
        this.$set(this.form_filter3, "date", val);
        this.get_yx_trends();
      }
    },
    clicksearchtype: function clicksearchtype(index) {
      if (index == 1) {
        this.button1 = "new_button_check";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 1; // this.$set(this.form_filter2, "search_type", 1);
      }

      if (index == 2) {
        this.button1 = "new_button";
        this.button2 = "new_button_check";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 1;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 2; //this.$set(this.form_filter2, "search_type", 2)
      }

      if (index == 3) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button_check";
        this.button4 = "new_button";
        this.is_day = 0;
        this.is_month = 1;
        this.is_year = 0;
        this.form_filter2.search_type = 3; //this.$set(this.form_filter2, "search_type", 3)
      }

      if (index == 4) {
        this.button1 = "new_button";
        this.button2 = "new_button";
        this.button3 = "new_button";
        this.button4 = "new_button_check";
        this.is_day = 0;
        this.is_month = 0;
        this.is_year = 1;
        this.form_filter2.search_type = 4; //this.$set(this.form_filter2, "search_type", 4)
      }

      this.get_rl_trends();
    },
    web_shuaxin: function web_shuaxin() {
      web_issue_order({
        did: this.did,
        tab_check: this.tab_check,
        device_type: 2
      }).then(function (res) {}); //setTimeout(() => { this.iotdatalastget() }, 6000)
    },
    web_shuaxin2: function web_shuaxin2() {
      var _this3 = this;

      web_issue_order({
        did: this.did,
        tab_check: this.tab_check,
        device_type: 2
      }).then(function (res) {});
      setTimeout(function () {
        _this3.iotdatalastget();
      }, 6000);
    },
    change_tab2: function change_tab2(name) {
      this.tab_check = name; //alert(this.tab_check)

      if (this.tab_check == "固件升级") {
        this.check_new();
        clearInterval(this.dingshi);
        clearInterval(this.progress_dingshi);
      } else if (this.tab_check == "PACK详情数据" || this.tab_check == "汇总数据") {
        //alert(123)
        this.get_rl_trends();
        this.get_yx_trends();
      }

      if (this.tab_check != "固件升级") {
        clearInterval(this.dingshi);
        clearInterval(this.progress_dingshi);
        this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
      }

      if (name === "参数设置") {
        var _vm = this;

        console.log("vm.$refs.control", _vm.$refs.control);

        _vm.$refs.control[0].clicktab();
      }
    },
    check_firmware: function check_firmware() {},
    change_tab: function change_tab(name) {
      this.details_data = []; // this.caiyang_pinglv = [];
      // this.dui = [];
      // this.bingji = [];

      var didstr = name.split(" "); //alert(name);

      this.check_did = didstr[0];
      this.iotdatalastget(didstr[0]);
      debugger;

      if (name === "参数设置") {
        this.$refs.control.clicktab();
      }
    },
    nibianqi_change: function nibianqi_change(value, type) {
      var _this4 = this;

      //   console.log(event)
      //  return
      config_nibianqi({
        value: value,
        type: type,
        did: this.did
      }).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this4.$Message.success(msg);
        } else {
          _this4.$Message.error(msg);
        }
      });
    },
    //查看详情
    iotdatalastget: function iotdatalastget(did) {
      var _this5 = this;

      // alert(1);
      // return;
      if (did) {
        this.did = did;
      } else {
        if (this.check_did) {
          this.did = this.check_did;
        } else {
          var q = this.$route.query;
          this.did = q.did;
        }
      }

      var bj_arr = [];

      for (var bj in this.bingji) {
        var bj_str = this.bingji[bj].split(" ");
        bj_arr.push(bj_str[0]);
      }

      var web_time = 0;
      console.log('SDAD', this.$route.query.web_time);

      if (this.$route.query.web_time != undefined) {
        web_time = parseInt(this.$route.query.web_time);
        this.is_web_time = 0;
        this.button1 = "new_button";
        this.button2 = "new_button_check";
        this.button3 = "new_button";
        this.button4 = "new_button";
        this.is_day = 1;
        this.is_month = 0;
        this.is_year = 0;
        this.form_filter2.search_type = 2;
        this.form_filter2.search_type = 2;
        this.form_filter2.search_date = formatYMD(parseInt(this.$route.query.web_time));
      } else {
        web_time = 0;
        this.is_web_time = 1;
      }

      _iotdatalastget({
        did: this.did,
        bingji: bj_arr,
        tab_check: this.tab_check,
        device_type: 2,
        web_time: web_time
      }).then(function (res) {
        get_now_lnglat({
          did: _this5.did
        }).then(function (res1) {
          _this5.deviclposition[0] = res1.body.lng;
          _this5.deviclposition[1] = res1.body.lat;
          console.log("resres", res1);

          _this5.loadMap(res1.body.lng, res1.body.lat);

          if (res.body.hasOwnProperty("历史轨迹")) {
            // 有历史估计，按经纬度显示地图
            console.log("中心点11", res1.body);
            _this5.qr_boolean = false;
            _this5.qr_boolean_click = true;
          } else {
            _this5.qr_boolean = true;
            _this5.qr_boolean_click = false;

            _this5.getQrCode(_this5.did, false);
          }
        }); //         if (res.body.汇总数据[0] != "nodata") {
        //           this.battery = res.body.汇总数据.状态.find(
        //             item => item.name_cn === "SOC"
        //           ).value;
        //           console.log("res.body.汇总数据[0]111", res.body.汇总数据.容量);
        // const target = res.body.汇总数据.容量.find(item => item.name_cn === "累计充电容量");
        // if (target) {
        //   target.value = this.charge /10;
        // }
        // const target1 = res.body.汇总数据.容量.find(item => item.name_cn === "累计放电容量");
        // if (target1) {
        //   target1.value = this.discharge /10;
        // }
        //           this.SN = res.other.sn;
        //           this.assign_time = res.other.assign_time;
        //         }

        if (res.body.汇总数据[0] != "nodata") {
          _this5.battery = res.body.汇总数据.状态.find(function (item) {
            return item.name_cn === "SOC";
          }).value;
          _this5.SN = res.other.sn;
          _this5.assign_time = res.other.assign_time;
        }

        _this5.tableLoading = false;
        _this5.spinShow = false;
        _this5.tableDataList = [];

        if (res.result === 0) {
          var length = Object.keys(res.body).length;

          if (_this5.is_web_time == 1) {
            _this5.check_new();
          } // console.log(res)
          // return


          if (res.body["PACK详情数据"][0] != "nodata") {
            _this5.pack_data = res.body["PACK详情数据"];
            res.body["PACK详情数据"] = _this5.pack_data[_this5.pack_check - 1];
          }

          console.log("333", res.body["单体数据"]);

          if (!_this5.$route.query.web_time && res.body["单体数据"][0] != "nodata") {
            _this5.pack_data_dt = res.body["单体数据"];
            console.log("111", _this5.pack_data_dt); //res.body['单体数据']=[]
            //res.body['单体数据'].splice(0, res.body['单体数据'].length)

            console.log("xiaoxie", _this5.pack_data_dt[_this5.pack_check - 1]);
            res.body["单体数据"] = {
              "": _this5.pack_data_dt[_this5.pack_check - 1]
            };
          }

          _this5.show_caiyang = true;
          _this5.details_data = res.body;
          console.log("单体数据222", res.body);
          _this5.caiyang_pinglv = res.other.caiyang_pinglv;
          _this5.dui = res.other.dui;
          _this5.chans = res.other.chans;

          if (res.other.chans.length == 1) {
            _this5.pack_check = 1;
          }

          _this5.bingji = res.other.bingji; //console.log("数据",res)
          //this.form_filter3.date=res.other.date

          console.log("this.$route.query.web_time", _this5.$route.query.web_time);
          _this5.form_filter3.date = _this5.$route.query.web_time != undefined ? formatYMD(parseInt(_this5.$route.query.web_time)) : res.other.date; //this.rongliang_trends=res.other.rongliang_trends
          //循环找到逆变器

          _this5.zhexian(res);

          if (res.body["设备信息"]) {
            for (var i in res.body["设备信息"][""]) {
              var list = res.body["设备信息"][""][i]; //console.log("aasdf"+list['name_cn'])

              if (list.type == "can_line") {
                //console.log(list['old'])
                _this5.can_lineData = list["old"];
                console.log("this.can_lineData", _this5.can_lineData);
              } else if (list.type == "chuan_line") {
                _this5.chuan_lineData = list["old"];
              } else if (list.type == "wang_line") {
                _this5.wang_lineData = list["old"];
              }

              if (list.name_en == "dcac_canid") {
                _this5.formModel.dcac_canid = list["old"];
                console.log("this.can_lineData", _typeof(_this5.formModel.dcac_canid));
              } else if (list.name_en == "dcac_comid") {
                _this5.formModel.dcac_comid = list["old"];
              } else if (list.name_en == "dcac_netid") {
                _this5.formModel.dcac_netid = list["old"];
              }
            }
          } //设置发送刷新命令


          console.log(_this5.shuaxin); //(alert(1), 5000)

          if (_this5.is_web_time == 1) {
            setTimeout(function () {
              _this5.web_shuaxin();
            }, (_this5.shuaxin - 4) * 1000);
          } //this.$nextTick(() => {
          //   setTimeout(alert( (this.shuaxin - 2) * 1000), (this.shuaxin - 2) * 1000)
          // }) //this.web_shuaxin()
          // this.can_lineData =

        } else {
          _this5.tableDataList = [];
          _this5.getPageTotal = 0;

          _this5.$Message.error(res.errorMsg);
        }
      });
    },

    /**
     * 升级固件
     */
    uploadFirmware: function uploadFirmware(dp_chan) {
      var did = this.did;
      this.result_firmware = [];
      var vm = this;
      var config = {
        title: this.$t("升级"),
        loading: true,
        content: this.$t("您确定要升级通道") + dp_chan + this.$t("的固件吗？"),
        onOk: function onOk() {
          var _this = this;

          upup_firmware({
            did: did,
            dp_chan: dp_chan
          }).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              vm.$Modal.remove();
              _this.buttonLoading = false; // this.getFirmwareInfo()
              //拉取进度

              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0; // vm.progress_dingshi = setInterval(vm.progress, 5000);

              vm.progress_dingshi = setInterval(function () {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    uploadFirmwareCc: function uploadFirmwareCc(dp_chan) {
      var did = this.did;
      console.log('uploadFirmwareCc', did);
      var config = {
        title: "产测升级",
        loading: true,
        content: "您确定要产测升级" + dp_chan + "的固件吗？",
        onOk: function onOk() {
          var _this6 = this;

          var dpcmd = {
            dpcmd: {
              t: 0,
              did: did,
              sdid: "",
              seq: 1,
              timestamp: parseInt(new Date().getTime() / 1000),
              ans: false,
              dpv_count: 1,
              dps: [{
                dp_id: 131,
                dp_type: 1,
                dp_chan: dp_chan,
                val_int64: 5
              }]
            }
          };
          dldpset(dpcmd).then(function (res) {
            if (res.result == 0) {
              var _this = _this6;
              _this6.result_firmware = [];
              var _vm2 = _this6;
              upup_firmware({
                did: did,
                dp_chan: dp_chan
              }).then(function (res) {
                if (res.result === 0) {
                  _this.$Message.success(res.errorMsg);

                  _vm2.$Modal.remove();

                  _this.buttonLoading = false; // this.getFirmwareInfo()
                  //拉取进度

                  _vm2.firmware_list[dp_chan].is_jindu = 1;
                  _vm2.firmware_list[dp_chan].is_shengji = 0; // vm.progress_dingshi = setInterval(vm.progress, 5000);

                  _vm2.progress_dingshi = setInterval(function () {
                    _vm2.progress(dp_chan);
                  }, 3000);
                } else {
                  _this.$Message.error(res.errorMsg);

                  _this.buttonLoading = false;
                }
              });
            } else {
              _this6.$Message.error("下发失败");
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    get_yx_trends: function get_yx_trends() {
      var _this7 = this;

      var pdata = {};

      if (this.chans != "" && this.tab_check != "汇总数据") {
        pdata = {
          did: this.did,
          date: this.form_filter3.date,
          dp_chan: this.pack_check
        };
      } else {
        pdata = {
          did: this.did,
          date: this.form_filter3.date
        };
      }

      _get_yx_trends(pdata).then(function (res) {
        _this7.tableLoading = false;
        console.log("运行数据", res);

        _this7.alertTimeList3.splice(0);

        _this7.alertDataList3.splice(0);

        if (res.result === 0) {
          if (res.body.yunxing_trends && res.body.yunxing_trends.length > 0) {
            //趋势数据
            var tem1 = [];
            var tem3 = [];
            var tem4 = [];
            var tem5 = [];
            var tem6 = [];
            var tem7 = [];
            var tem8 = [];
            var tem9 = [];
            var tem10 = [];
            var x_axis = 0;
            var xzhou = [];

            for (var i = 0; i < res.body["yunxing_trends"].length; i++) {
              var list = res.body["yunxing_trends"][i];
              tem1.push(list["voltage"]);
              x_axis = list["timestamp"];
              xzhou.push(x_axis); // this.alertTimeList3.push(x_axis)

              tem3.push(list["current"]);
              tem4.push(list["soc"]);
              tem5.push(list["soh"]);
              tem6.push(list["remainder_capacity"]);
              tem7.push(list["max_single_voltage"]);
              tem8.push(list["min_single_voltage"]);
              tem9.push(list["max_temperature"]);
              tem10.push(list["min_temperature"]);
            }

            console.log("数据1", res.body);
            console.log("数据2", _this7.alertDataList3);
            _this7.alertTimeList3 = xzhou; // this.alertTimeList3=xzhou
            //  this.alertTimeList3 = xzhou

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.总电压") + "(v)",
              data: tem1,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#1400FF"
                }, {
                  offset: 1,
                  color: "#C3BEFF" //'rgba(14,0,255,0.1)',

                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.电流") + "(mA)",
              data: tem3,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#000000"
                }, {
                  offset: 1,
                  color: "#cccccc"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.SOC") + "(%)",
              data: tem4,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#19741D"
                }, {
                  offset: 1,
                  color: "#b7cbac"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.SOH") + "(%)",
              data: tem5,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#FF7D7D"
                }, {
                  offset: 1,
                  color: "#f8c5bf"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.剩余容量") + "(Ah)",
              data: tem6,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#00C2FF"
                }, {
                  offset: 1,
                  color: "#98dbec"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.最高电压") + "(mv)",
              data: tem7,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#52FF00"
                }, {
                  offset: 1,
                  color: "#c7f2a3"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.最低电压") + "(mv)",
              data: tem8,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#FF8F8F"
                }, {
                  offset: 1,
                  color: "#f8dcd5"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.最高温度") + "(°C)",
              data: tem9,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#FF00E5"
                }, {
                  offset: 1,
                  color: "#f8c3e7"
                }])
              }
            });

            _this7.alertDataList3.push({
              name: _this7.$t("Changelang.最低温度") + "(°C)",
              data: tem10,
              type: "line",
              lineStyle: {
                width: 2
              },
              smooth: true,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 0.01, [{
                  offset: 0,
                  color: "#00E0FF"
                }, {
                  offset: 1,
                  color: "#AFE9EC"
                }])
              }
            });
          } else {//this.is_update=0
            //this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this7.tableDataList = [];
          _this7.getPageTotal = 0;

          _this7.$Message.error(res.errorMsg);
        }
      });
    },
    get_rl_trends: function get_rl_trends() {
      var _this8 = this;

      var pdata = {};

      if (this.chans != "" && this.tab_check != "汇总数据") {
        pdata = {
          did: this.did,
          search_type: this.form_filter2.search_type,
          search_date: this.form_filter2.search_date,
          dp_chan: this.pack_check
        };
      } else {
        pdata = {
          did: this.did,
          search_type: this.form_filter2.search_type,
          search_date: this.form_filter2.search_date
        };
      }

      _get_rl_trends(pdata).then(function (res) {
        _this8.tableLoading = false;
        _this8.rongliang_trends = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.rongliang_trends && res.body.rongliang_trends.length > 0) {
            _this8.rongliang_trends = res.body.rongliang_trends;

            _this8.xAxisData3.splice(0);

            _this8.legendData3.splice(0);

            _this8.seriesData3.splice(0);

            var xAxis3 = [];
            var xAxis3_1 = [];

            if (_this8.rongliang_trends && _this8.rongliang_trends.length > 0) {
              for (var j in _this8.rongliang_trends) {
                _this8.xAxisData3.push(_this8.rongliang_trends[j].x_axis);

                xAxis3.push(_this8.rongliang_trends[j].total_chongdian);
                xAxis3_1.push(_this8.rongliang_trends[j].total_fangdian);
              }
            }

            _this8.seriesData3.push({
              name: _this8.$t("累计充电容量") + "(mAh)",
              type: "bar",
              tooltip: {
                valueFormatter: function valueFormatter(value) {
                  return value + " mAh";
                }
              },
              data: xAxis3
            }, {
              name: _this8.$t("累计放电容量") + "(mAh)",
              type: "bar",
              tooltip: {
                valueFormatter: function valueFormatter(value) {
                  return value + " mAh";
                }
              },
              data: xAxis3_1
            });
          } else {//this.is_update=0
            //this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this8.tableDataList = [];
          _this8.getPageTotal = 0;

          _this8.$Message.error(res.errorMsg);
        }
      });
    },
    //检测新的固件版本
    check_new: function check_new(chan_id) {
      var _this9 = this;

      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({
        did: this.did
      }).then(function (res) {
        _this9.tableLoading = false;
        _this9.tableDataList = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (_this9.is_update === 0) {//  this.$Message.info("已经是最新版本")
            } else {} //  this.$Message.success("检测出可升级的固件")
              //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)


            console.log("res.body.firmware", res.body.firmware);
            _this9.firmware_list = res.body.firmware;

            if (chan_id == 0 || chan_id > 0) {
              _this9.$Message.success(_this9.$t("检测成功"));
            }
          } else {
            _this9.is_update = 0; //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this9.tableDataList = [];
          _this9.getPageTotal = 0;

          _this9.$Message.error(res.errorMsg);
        }
      });
    },
    init: function init() {
      this.shuaxin = 60;
      localStorage.setItem("shuaxin", this.shuaxin);
      this.spinShow = true;
      this.shuaxin = localStorage.getItem("shuaxin") || 10; //获取设备信息

      this.iotdatalastget();
      this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000); //setTimeout( this.web_shuaxin(), 2000 )
    },
    pinglvbox: function pinglvbox() {
      clearInterval(this.dingshi);
      this.modal7 = true;
    },
    changepinglv: function changepinglv() {
      clearTimeout(this.pinglvdingshi);
      this.changepl = localStorage.getItem("changepl") ? localStorage.getItem("changepl") : 0;

      if (this.changepl == 0) {
        this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000);
      } // alert(123)

    },
    modal7cancel: function modal7cancel() {
      //debugger
      clearInterval(this.dingshi);
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
      clearTimeout(this.pinglvdingshi);
      this.pinglvdingshi = setTimeout(this.pinglvbox, 300 * 1000);
    },
    modal7Ok: function modal7Ok() {
      // debugger
      clearInterval(this.dingshi); //clearTimeout(this.pinglvdingshi)

      this.shuaxin = 3600;
      localStorage.setItem("shuaxin", this.shuaxin);
      localStorage.setItem("changepl", 1);
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
    },
    //刷新频率
    progress: function progress(dp_chan) {
      var _this10 = this;

      var did = this.did;
      progress_firmware({
        did: did,
        dp_chan: dp_chan
      }).then(function (res) {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(function () {
              _this10.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          } // //拉取进度
          //this.is_jindu = 1;


          _this10.firmware_list[dp_chan].is_jindu = 1;

          if (res.body.jindu == 100) {
            clearInterval(_this10.progress_dingshi);
          }

          _this10.firmware_list[dp_chan].progress_percent = res.body.jindu;
          _this10.firmware_list[dp_chan].progress_text = res.body.ext_code;
          console.log(_this10.result_firmware);

          if (_this10.result_firmware.length >= 6) {
            var last = _this10.result_firmware.length - 1;

            if (_this10.result_firmware[last] == _this10.result_firmware[last - 1] && _this10.result_firmware[last] == _this10.result_firmware[last - 2] && _this10.result_firmware[last] == _this10.result_firmware[last - 3] && _this10.result_firmware[last] == _this10.result_firmware[last - 4] && _this10.result_firmware[last] == _this10.result_firmware[last - 5] && _this10.result_firmware[last] == _this10.result_firmware[last - 6]) {
              clearInterval(_this10.progress_dingshi); //this.$Message.error("固件升级超时，升级失败")

              _this10.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });

              _this10.check_new();
            }
          }

          _this10.result_firmware.push(res.body.jindu);
        } else {
          _this10.$Message.error(res.errorMsg); //this.is_jindu = 0;


          _this10.firmware_list[dp_chan].is_jindu = 0; //this.is_shengji = 1

          _this10.firmware_list[dp_chan].is_shengji = 1; //this.progress_percent = 0;

          _this10.firmware_list[dp_chan].progress_percent = 0; //this.progress_text = "";

          _this10.firmware_list[dp_chan].progress_text = "";
          clearInterval(_this10.progress_dingshi);
        } //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }

      });
    },
    refresh: function refresh() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, "刷新频率"), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(refreshCustom, {
            ref: "refreshCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              shuaxin: localStorage.getItem("shuaxin") || 10,
              parent_code: "0",
              parent_name: "无"
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.refreshCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // console.log(obj.formModel)
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success(vm.$t("设置成功"));
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin); //     vm.init()
            }
          }); // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    more: function more(title, morevalue) {
      var _this11 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        okText: this.$t("关闭"),
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this11.$t("Changelang." + title)), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(moreCustom, {
            ref: "moreCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              parent_code: "0",
              parent_name: "无",
              morevalue: morevalue
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.moreCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              // vm.$Message.success("");
              vm.$Modal.remove(); //vm.init()
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.success(config);
    },
    sampling: function sampling() {
      var _this12 = this;

      //   alert(sampling)
      //  return;
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this12.$t("采样频率设置")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(samplingCustom, {
            ref: "samplingCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: "0",
              parent_name: "无",
              did: vm.did,
              caiyang_pinglv: _this12.caiyang_pinglv
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.samplingCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              //this.caiyang_pinglv=obj.formModel.sampling_value
              config_caiyang_pinglv(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  //console.log('aaa',obj.formModel.sampling_value)
                  var _msg = res.errorMsg;
                  vm.$Message.success(_msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    handleSelectAll: function handleSelectAll(status) {
      this.$refs.selection.selectAll(status);
    },
    reset: function reset() {
      this.form_filter = {
        tabname: null
      };
      var str = "";

      for (var i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = true;
      } // this.search()

    },
    search: function search() {
      var str = "";

      for (var i = 1; i <= 32; i++) {
        str = "" + "show1_" + i;
        this[str] = false;
      }

      var xuhao = 0;

      for (var _i4 in this.form_filter.tabname) {
        xuhao = parseInt(_i4) + 1;
        str = "" + "show1_" + xuhao;
        console.log(str);
        this[str] = true;
      }
    },
    copyToClipboard: function copyToClipboard(text) {
      var _this13 = this;

      navigator.clipboard.writeText(text).then(function () {
        // alert('已复制: ' + text);
        _this13.$Message.success(_this13.$t("复制成功"));
      }).catch(function (err) {
        console.error("复制失败:", err);
      });
    },
    getQrCode: function getQrCode(id, isChange) {
      var _this14 = this;

      if (this.qr_boolean_click) {
        get_qr_code({
          did: id
        }).then(function (res) {
          if (res.result == 0) {
            _this14.qr_url = res.body.qrcode_url;
            _this14.qr_boolean = !_this14.qr_boolean;
          }
        });
        return;
      } else {
        get_qr_code({
          did: id
        }).then(function (res) {
          if (res.result == 0) {
            _this14.qr_url = res.body.qrcode_url;

            if (isChange !== undefined) {}
          }
        });
      }
    },
    loadMap: function loadMap(lng, lat) {
      console.log("中心点", lng, lat); // let count_gj = this.pathList.length - 1;

      this.map = new AMap.Map("container", {
        zoom: 16,
        //级别
        center: [lng, lat] //中心点坐标 默认在杭州

      });
      var startIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        // 图标尺寸
        image: "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
        // 图标的取图地址
        imageSize: new AMap.Size(135, 40),
        // 图标所用图片大小
        imageOffset: new AMap.Pixel(-9, -3) // 图标取图偏移量

      }); // 创建一个 Marker

      var marker = new AMap.Marker({
        position: [lng, lat],
        // 图标位置
        icon: startIcon // 使用自定义图标

      }); // 将 Marker 添加到地图

      marker.setMap(this.map); // 创建一个 Icon
      // var startIcon = new AMap.Icon({
      //   // 图标尺寸
      //   size: new AMap.Size(25, 34),
      //   // 图标的取图地址
      //   image:
      //     "https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
      //   // 图标所用图片大小
      //   imageSize: new AMap.Size(135, 40),
      //   // 图标取图偏移量
      //   imageOffset: new AMap.Pixel(-9, -3),
      // });
      // 将 icon 传入 marker
      //   var startMarker = new AMap.Marker({
      //     map:this.map,
      //     position: new AMap.LngLat(this.pathList[0][0], this.pathList[0][1]),
      //     icon: startIcon,
      //     offset: new AMap.Pixel(-13, -30)
      //   });
      //         // 创建一个 icon
      // var endIcon = new AMap.Icon({
      //     size: new AMap.Size(25, 34),
      //     image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
      //     imageSize: new AMap.Size(135, 40),
      //     imageOffset: new AMap.Pixel(-95, -3)
      // });
      // // 将 icon 传入 marker
      //   var endMarker = new AMap.Marker({
      //     map:this.map,
      //     position: new AMap.LngLat(this.pathList[count_gj][0], this.pathList[count_gj][1]),
      //     icon: endIcon,
      //     offset: new AMap.Pixel(-13, -30)
      // });
      //       return new Promise((reslove, reject) => {
      //           //加载PathSimplifier，loadUI的路径参数为模块名中 'ui/' 之后的部分
      //           new AMapUI.load(['ui/misc/PathSimplifier'], PathSimplifier => {
      //               if (!PathSimplifier.supportCanvas) {
      //                   alert('当前环境不支持 Canvas！');
      //                   return;
      //               }
      //               if (this.pathList.length) {
      //                   //启动页面
      //                   this.initPage(PathSimplifier);
      //               }
      //           });
      //           reslove();
      //       });
    },
    getImageSrc: function getImageSrc(value) {
      console.log("valuevalue111", value);

      if (value >= 0 && value <= 10) {
        return require("@/assets/images/lowD.png");
      } else if (value >= 11 && value <= 30) {
        return require("@/assets/images/centerD.png");
      } else if (value >= 31 && value <= 60) {
        return require("@/assets/images/heightD.png");
      } else if (value >= 61 && value <= 100) {
        return require("@/assets/images/fullD.png");
      }

      return ""; // 默认值
    },
    swicthPassword: function swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    savepassword: function savepassword() {
      did_config_pass({
        pass: this.password,
        did: this.did
      }).then(function (res) {
        if (res.result === 0) {
          var _msg2 = res.errorMsg;
          vm.$Message.success(_msg2);
        } else {
          vm.$Message.error(msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var storedLang = localStorage.getItem("local");

    if (storedLang) {
      this.local = storedLang;
    }

    this.init();

    if (this.$route.query.web_time == undefined) {
      this.dingshi = setInterval(this.iotdatalastget, this.shuaxin * 1000);
    }

    var query = this.$route.query;

    if (query && query.tabname) {
      this.currDidTab = query.tabname;
    } // this.dingshi_shuaxin=setInterval(this.web_issue_order, this.shuaxin*1000);

  },
  destroyed: function destroyed() {
    clearInterval(this.dingshi);
    clearTimeout(this.pinglvdingshi); //localStorage.setItem('shuaxin', 60);
  },
  watch: {
    $route: function $route(to, from) {
      clearInterval(this.dingshi);
    }
  }
};